import ApiService from 'services/ApiService';
import ApiRequestService from 'services/ApiRequestService';

const badRequestCode = 400;
const incidentSystemMessageTypeId = 2;

export const SystemMessagesService = {
    searchSystemMessages(searchRequest) {
        return ApiRequestService.post('system', 'SystemMessages/Search', searchRequest);
    },
    getAllSystemMessages(isCurrent) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/system/SystemMessages?current=${isCurrent}`).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                });
        });
    },
    getSystemMessage(systemMessageId) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/system/SystemMessages/${systemMessageId}`).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                });
        });
    },
    saveSystemMessage(systemMessage) {
        systemMessage = applyIncidentActiveState(systemMessage);
        systemMessage = encodeUrl(systemMessage);
        return new Promise((resolve, reject) => {
            ApiService.post('/system/SystemMessages', systemMessage)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if (error.response.status === badRequestCode) {
                        reject(error.response);
                    } else {
                        reject(error);
                    }
                })
        });
    },
    updateSystemMessage(systemMessageId, systemMessage) {
        systemMessage = applyIncidentActiveState(systemMessage);
        systemMessage = encodeUrl(systemMessage);
        return new Promise((resolve, reject) => {
            ApiService.put(`/system/SystemMessages/${systemMessageId}`, systemMessage)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    if (error.response.status === badRequestCode) {
                        reject(error.response);
                    } else {
                        reject(error);
                    }
                })
        });
    }
}



// An incident shows on Vision until an end date closes it, so the end date is what decides whether
// it is active.
function applyIncidentActiveState(systemMessage) {
    if (systemMessage.systemMessageTypeID !== incidentSystemMessageTypeId) {
        return systemMessage;
    }

    return { ...systemMessage, active: systemMessage.endDate == null };
}

function encodeUrl(systemMessage) {
    if (systemMessage.url === "") {
        return systemMessage;
    }

    return { ...systemMessage, url: encodeURIComponent(systemMessage.url) };
}